export class CategoryModel {
    constructor(payload) {
        Object.assign(this, payload);
    }
    get order() {
        return this.position;
    }
}
